// Components
import { UpdateProviderConfigForm } from './UpdateProviderConfigForm';
import { ClosableModal } from '@Components/shared/dialogs/ClosableModal';
// Redux
import { useUpdateProviderConfig } from '@Modal/hooks/providers/useUpdateProviderConfig';
// styles
import Styles from './UpdateProviderConfigModalDialog.module.scss';

export const UpdateProviderConfigModalDialog = () => {
  const { showUpdateProviderConfigForm, handleUpdateCancel } = useUpdateProviderConfig();

  return (
    <>
      {showUpdateProviderConfigForm && (
        <ClosableModal
          name="UpdateProviderConfig"
          title="Update Provider Config"
          open={showUpdateProviderConfigForm}
          onClose={handleUpdateCancel}
          className={Styles.UpdateProviderConfigModalDialog}
          sx={{ height: '90vh', overflowY: 'scroll', width: '592px' }}
        >
          <UpdateProviderConfigForm />
        </ClosableModal>
      )}
    </>
  );
};
